import { Case, match, matchAll } from './match';
import { Action } from './actions';
import { ApplicationState } from './types/application-state';

export const matchAllActions = (
  prevState: ApplicationState,
  nextState?: ApplicationState
) => (...cases: Case<Action>[]) =>
  matchAll<Action>(prevState, nextState)(...cases);

export const matchAction = (
  prevState: ApplicationState,
  nextState?: ApplicationState
) => (...cases: Case<Action>[]) =>
  match<Action>(prevState, nextState)(...cases);
